import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NxModule } from '@nrwl/nx';
import { AgmCoreModule } from '@agm/core';
import {
  RecaptchaModule,
  RECAPTCHA_SETTINGS,
  RECAPTCHA_NONCE,
  RecaptchaSettings
} from 'ng-recaptcha';

import { Environment, DialogsModule } from '@finders/finder';
import { environment, staticObjectEnv } from '../environments/environment';

import { HeaderModule } from './header/header.module';
import { FooterModule } from './footer/footer.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    NxModule.forRoot(),
    HeaderModule,
    FooterModule,
    DialogsModule,
    HttpClientModule,
    AppRoutingModule,
    AgmCoreModule.forRoot({
      // StaticObjectEnv is _required_ to make this work even though it feels wrong since we're
      // doing the abstract class thing to provide environments to child modules. We can't use those
      // references in a decorator or typescript complains.
      apiKey: staticObjectEnv.googleMapsApiKey,
      libraries: ['places']
    }),
    RecaptchaModule.forRoot()
  ],
  providers: [
    { provide: Environment, useValue: environment },
    {
      provide: RECAPTCHA_NONCE,
      useValue: 'prolia-finder'
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: staticObjectEnv.recaptchaApiKey
      } as RecaptchaSettings
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
